<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>
    <div class="fora" v-else>
      <div class="index centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
        <div class="topo-index">
          <h1>Formulários</h1>
          <router-link v-if="podeEscrever('formularios')" :to="{ name: 'FormularioNew' }">
            <span>+</span> Novo Formulário
          </router-link>
        </div>
        
        <div class="caixa-pesquisa">
          <h2 @click="tooglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
          <transition name="slide">
            <form @submit.prevent="fazerBusca" v-if="!exibirPesquisa">
              
              <div class="row2-data">
                <div class="item">
                  <label> Título do Formulário: </label>
                  <input
                    type="text"
                    placeholder="Digite o título para buscar"
                    v-model="filtro.titulo"
                  />
                </div>
                <div class="item">
                  <label> Unidade Organizacional: </label>
                  <select v-model="filtro.id_unidade">
                    <option :value="null">Todas</option>
                    <option
                      v-for="unidade in unidades"
                      :key="unidade.id"
                      :value="unidade.id"
                    >
                      {{ unidade.nome }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row2-data">
                <div class="item">
                  <label> Data de Início: </label>
                  <input type="date" v-model="filtro.data_inicio" />
                </div>
                <div class="item">
                  <label> Data de Encerramento: </label>
                  <input type="date" v-model="filtro.data_final" />
                </div>
              </div>

              <div class="botoes-pesquisa">
                <div class="bt-pesquisa">
                  <button title="Pesquisar" type="submit">
                    <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                    Pesquisar
                  </button>
                </div>
                <div class="bt-limpar">
                  <button type="button" title="Limpar" @click="limparFiltro()">
                    <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
            <label>Total de Resultados: {{ this.totalResultadosTexto }}</label>
          </div>
          <div class="npagina" v-show="!carregando">
            <label>Resultados por Página </label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>
        </div>
        <div class="container-tabela">
          <TabelaResultadosFormularios :formularios="formularios" v-if="!carregando && !erro && !erroFiltro" />
        </div>
        <paginate v-if="!carregandoFiltro && !carregando" v-model="pagina" :page-count="pageCount"
            :click-handler="mudouPagina" :prev-text="'Anterior'" :next-text="'Próxima'" :container-class="'className'"
            active-class="active-page"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  import Paginate from "vuejs-paginate";
  import tryParseInt from "../../helpers/tryParseInt";
  import metaDados from "../../helpers/metaDados";


  import TabelaResultadosFormularios from "../../components/formularios/TabelaResultadosFormularios.vue";
  import FormularioApi from "../../services/FormularioApi";
  import MsgErroFormularios from "../../components/MsgErroFormularios.vue";

  export default {

    name: "Formularios",
    metaInfo() {
        return {
        title: "Formularios",
        titleTemplate: "%s - Casa Civil do Estado de Goiás",
        meta: [
            {
            vmid: "description",
            name: "description",
            content: "Página de listagem e busca de formularios.",
            },            
            ...metaDados(this.$route),
        ],
        };
    },
    data() {
      return {
        formularios: [],
        carregando: true,
        msgErros: {
          formulario: '',
        },
        erro: false,
        totalResultados: null,
        totalResultadosTexto: null,
        pagina: 1,
        qtd_por_pagina: 10,
        filtro: { // Seu filtro já estava correto
          titulo: null,
          id_unidade: null,
          data_inicio: null,
          data_final: null,
        },
        exibirPesquisa: true,
        carregandoFiltro: false,
        erroFiltro: false,

        // --- ADICIONADO ---
        unidades: [], // Para o dropdown
      };
    },
    components: {
      MsgErroFormularios,
      TabelaResultadosFormularios,
      Paginate,
    },
    created() {
      this.formularioApi = new FormularioApi();
      this.carregarQtdPorPagina();
      this.carregarValoresFiltro();
      this.carregarFormularios(); 
      this.carregarUnidades(); 
    },
    watch: {
      $route: function (to, from) {
        // Seu watch já estava correto e incluía todos os campos do filtro
        const mudouQuery =
          to.query.pagina != from.query.pagina ||
          to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
          to.query.titulo != from.query.titulo ||
          to.query.id_unidade != from.query.id_unidade ||
          to.query.data_inicio != from.query.data_inicio ||
          to.query.data_final != from.query.data_final
        if (
          from.name == "Formularios" &&
          to.name == "Formularios" &&
          mudouQuery
        ) {
          this.carregarValoresFiltro();
          this.carregarFormularios();
        }
      },
    },
    methods: {
      // --- MÉTODO ADICIONADO ---
      async carregarUnidades() {
        try {
          // Vamos assumir que FormularioApi terá o método getUnidades
          this.unidades = await this.formularioApi.getUnidades();
        } catch (err) {
          console.error("Erro ao carregar unidades:", err);
        }
      },
      // --- FIM DO MÉTODO ADICIONADO ---

      // O restante dos seus métodos permanece IDÊNTICO
      tooglePesquisa: function () {
        this.exibirPesquisa = !this.exibirPesquisa;
      },
      fazerBusca() {
        this.$router.push({
          name: "Formularios",
          query: {
            ...this.filtro,
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      mudouQtdPagina: function (event) {
        const novaQtdPagina = parseInt(event.target.value);
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(1);
      },
      getParam: function (name) {
        if (this.$route && this.$route.query) {
          return this.$route.query[name];
        }
        return null;
      },
      mudouPagina: function (page) {
        this.pagina = page;
        this.$router.push({
          name: "Formularios",
          query: {
            ...this.filtro,
            pagina: this.pagina,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      carregarValoresFiltro: function () {
        this.filtro = {
          titulo: this.getParam("titulo"),
          id_unidade: this.getParam("id_unidade"),
          data_inicio: this.getParam("data_inicio"),
          data_final: this.getParam("data_final"),
        };
      },
      carregarFormularios: async function () {
        try {
          this.carregando = true;
          this.erro = false;

          this.qtd_por_pagina = this.getParam("qtd_por_pagina") || this.qtd_por_pagina;
          this.armazenarQtdPorPagina();
          this.pagina = parseInt(this.getParam("pagina") || 1);
          this.carregarValoresFiltro();

          if (this.formularioApi.cancelTokens.getFormularios) {
            this.formularioApi.cancelTokens.getFormularios.cancel();
          }

          let data = await this.formularioApi.getFormularios({
            ...this.filtro,
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          });

          this.formularios = data.resultados;
          this.totalResultados = data.total_resultados;
          this.totalResultadosTexto = data.total_resultados;
          this.carregando = false;

        } catch (err) {
          if (this.formularioApi.isCancel(err)) {
            return;
          }
          console.log("carregarFormularios", err);
          this.carregando = false;
          this.erro = true;
        }
      },
      limparFiltro: function () {
        this.filtro = {
          titulo: null,
          id_unidade: null,
          data_inicio: null,
          data_final: null,
        };
        this.fazerBusca();
      },
      armazenarQtdPorPagina() {
        localStorage.setItem("qtd_por_pagina_formularios", this.qtd_por_pagina);
      },
      carregarQtdPorPagina() {
        const qtd = localStorage.getItem("qtd_por_pagina_formularios");
        if (qtd) {
          this.qtd_por_pagina = tryParseInt(qtd);
        }
      },
    },
    computed: {
      pageCount: function () {
        if (this.totalResultados && this.qtd_por_pagina > 0) {
          return Math.ceil(this.totalResultados / this.qtd_por_pagina);
        }
        return 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
/* Seus estilos podem ser mantidos aqui */
</style>